import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'delete_role_form';
export const useDeleteRoleFormTranslation = (): UseTranslationResponse<'entities', typeof keyPrefix> => useTranslation('entities', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Удаление роли',
    description: 'Выберите новую роль всем пользователям с ролью {{roleName}}.',
    new_role: {
      label: 'Новая роль',
      placeholder: 'Выберите',
    },
    hint: 'Если ничего не выбрано, пользователи останутся без роли и вы сможете назначить им роли вручную.',
    delete_button: 'Удалить',
    cancel_button: 'Отмена',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Delete role',
    description: 'Select a new role for all users with the {{roleName}} role.',
    new_role: {
      label: 'New role',
      placeholder: 'Select',
    },
    hint: 'If nothing is selected, users will remain without a role and you can assign roles manually.',
    delete_button: 'Delete',
    cancel_button: 'Cancel',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Eliminar rol',
    description: 'Seleccione un nuevo rol para todos los usuarios con el rol {{roleName}}.',
    new_role: {
      label: 'Nuevo rol',
      placeholder: 'Seleccione',
    },
    hint: 'Si no se selecciona nada, los usuarios quedarán sin rol y podrá asignarles roles manualmente.',
    delete_button: 'Eliminar',
    cancel_button: 'Cancelar',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Excluir função',
    description: 'Selecione uma nova função para todos os usuários com a função {{roleName}}.',
    new_role: {
      label: 'Nova função',
      placeholder: 'Selecione',
    },
    hint: 'Se nada for selecionado, os usuários ficarão sem função e você poderá atribuí-las manualmente.',
    delete_button: 'Excluir',
    cancel_button: 'Cancelar',
  },
}) : {}) as Record<string, unknown>;
